<script>
    /**
     * @typedef {{
     *   caption: string
     *   channels: {
     *     caption: string
     *     description?: string
     *     link: string
     *   }[]
     * }} Categories
     *
     * @type {Categories} categories
     */
    const categories = [{
        caption: 'Tech (& news)',
        channels: [{
            caption: 'Linus Tech Tips',
            link: 'https://www.youtube.com/@LinusTechTips',
        }, {
            caption: 'ShortCircuit',
            link: 'https://www.youtube.com/@ShortCircuit',
        }, {
            caption: 'GamersNexus',
            link: 'https://www.youtube.com/@GamersNexus',
        }, {
            caption: 'Level1Techs',
            link: 'https://www.youtube.com/@Level1Techs',
        }, {
            caption: 'der8auer',
            link: 'https://www.youtube.com/@der8auer-en',
        }, {
            caption: 'Louis Rossmann',
            link: 'https://www.youtube.com/@rossmanngroup',
        }, {
            caption: 'TechLinked',
            link: 'https://www.youtube.com/@techlinked',
        }, {
            caption: 'Moore\'s Law Is Dead',
            link: 'https://www.youtube.com/@MooresLawIsDead',
        },]
    }, {
        caption: 'Gaming (& news)',
        channels: [{
            caption: 'Markiplier',
            link: 'https://www.youtube.com/@markiplier',
        }, {
            caption: 'ChilledChaos',
            link: 'https://www.youtube.com/@ChilledChaosGAME',
        }, {
            caption: 'Dooley Noted',
            link: 'https://www.youtube.com/@DooleyNotedGaming',
        }, {
            caption: 'Smii7Y',
            link: 'https://www.youtube.com/@SMii7Y',
        }, {
            caption: 'Raycevick',
            link: 'https://www.youtube.com/@Raycevick',
        }, {
            caption: 'Let\'s Game It Out',
            link: 'https://www.youtube.com/@LetsGameItOut',
        }, {
            caption: 'SovietWomble',
            link: 'https://www.youtube.com/@SovietWomble',
        }, {
            caption: 'GameLinked',
            link: 'https://www.youtube.com/@GameLinked',
        }, {
            caption: 'Tyler McVicker',
            link: 'https://www.youtube.com/@TylerMcVicker1',
        }, {
            caption: 'Games Done Quick',
            link: 'https://www.youtube.com/@gamesdonequick',
        },]
    }, {
        caption: 'Knowledge!',
        channels: [{
            caption: 'Technology Connections',
            link: 'https://www.youtube.com/@TechnologyConnections',
        }, {
            caption: 'Tom Scott',
            link: 'https://www.youtube.com/@TechnologyConnections',
        }, {
            caption: 'CGP Grey',
            link: 'https://www.youtube.com/@TomScottGo',
        }, {
            caption: 'LEMMiNO',
            link: 'https://www.youtube.com/@LEMMiNO',
        }, {
            caption: 'Stand-up Maths',
            link: 'https://www.youtube.com/@standupmaths',
        }, {
            caption: 'Vsauce',
            link: 'https://www.youtube.com/@Vsauce',
        }, {
            caption: 'Freya Holmér',
            link: 'https://www.youtube.com/@acegikmo',
        }, {
            caption: 'Sebastian Lague',
            link: 'https://www.youtube.com/@SebastianLague',
        }, {
            caption: 'Vsauce3',
            link: 'https://www.youtube.com/@Vsauce3',
        }, {
            caption: 'Last Week Tonight',
            link: 'https://www.youtube.com/@LastWeekTonight',
        },]
    }, {
        caption: 'Electronics',
        channels: [{
            caption: 'GreatScott!',
            link: 'https://www.youtube.com/@greatscottlab',
        }, {
            caption: 'ElectroBOOM',
            link: 'https://www.youtube.com/@ElectroBOOM',
        },]
    }, {
        caption: 'Web Development',
        channels: [{
            caption: 'Web Dev Simplified',
            link: 'https://www.youtube.com/@WebDevSimplified',
        }, {
            caption: 'Kevin Powell',
            link: 'https://www.youtube.com/@KevinPowell',
        },]
    }, {
        caption: 'Game Development',
        channels: [{
            caption: 'Game Maker\'s Toolkit',
            link: 'https://www.youtube.com/@GMTK',
        }, {
            caption: 'Brackeys',
            link: 'https://www.youtube.com/@Brackeys',
        }, {
            caption: 'AI and Games',
            link: 'https://www.youtube.com/@AIandGames',
        }, {
            caption: 'quill18creates',
            link: 'https://www.youtube.com/@quill18creates',
        }, {
            caption: 'Game Dev Guide',
            link: 'https://www.youtube.com/@GameDevGuide',
        },]
    }, {
        caption: 'Linux',
        channels: [{
            caption: 'Level1Linux',
            link: 'https://www.youtube.com/@Level1Linux',
        },{
            caption: 'Brodie Robertson',
            link: 'https://www.youtube.com/@BrodieRobertson',
        },]
    }, {
        caption: 'Streaming',
        channels: [{
            caption: 'EposVox',
            link: 'https://www.youtube.com/@EposVox',
        },]
    }, {
        caption: 'Design',
        channels: [{
            caption: 'Juxtopposed',
            link: 'https://www.youtube.com/@juxtopposed',
        },]
    }, {
        caption: 'Security',
        channels: [{
            caption: 'John Hammond',
            link: 'https://www.youtube.com/@_JohnHammond',
        }, {
            caption: 'LiveOverflow',
            link: 'https://www.youtube.com/@LiveOverflow',
        }, {
            caption: 'IppSec',
            link: 'https://www.youtube.com/@ippsec',
        },]
    }, {
        caption: 'Fun (& fascinating)',
        channels: [{
            caption: 'Matt and Tom',
            link: 'https://www.youtube.com/@mattandtom',
        }, {
            caption: 'The Technical Difficulties',
            link: 'https://www.youtube.com/@techdif',
        }, {
            caption: 'TomSka',
            link: 'https://www.youtube.com/@TomSka',
        }, {
            caption: 'The Slow Mo Guys',
            link: 'https://www.youtube.com/@theslowmoguys',
        },]
    },];
</script>

<style>
    .list {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .list + .block-title {
        margin-top: 50px;
    }

    .channel {
        display: flex;
        align-items: baseline;
        padding: 10px;
        border-radius: 8px;
        text-decoration: none;
        background: #363636;
        color: inherit;
    }

    /* .channel > i {
        margin-right: 10px;
        flex-shrink: 0;
        color: #1DB954;
    } */

    .channel > .info {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .channel .name {
        font-weight: 500;
    }

    .channel .description {
        color: #aaa;
    }

    .channel:hover {
        box-shadow: 0 0 0 3px #545454;
    }
</style>

{#each categories as category}
    <div class="block-title">
        <h2>{category.caption}</h2>
    </div>

    <div class="list">
        {#each category.channels as channel}
            <a class="channel" href="{channel.link}" target="_blank" rel="noopener noreferrer">
                <!-- <i class="fab fa-spotify"></i> -->
                <div class="info">
                    <div class="name">{channel.caption}</div>
                    {#if channel.description}
                        <div class="description">{channel.description}</div>
                    {/if}
                </div>
            </a>
        {/each}
    </div>
{/each}